var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('ChargeWallet')],1)])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }